import { Component, input } from '@angular/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';


@Component({
  selector: 'app-entity-info',
  imports: [FontAwesomeModule],
  templateUrl: './entity-info.component.html',
  styleUrl: './entity-info.component.scss'
})
export class EntityInfoComponent {
  name = input<string>('Entity');
  showInfoCard = true;
  faInfo = faInfo;
}
